'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

/** 제안형 시딩 거절 사유 목록 — 거절 사유 시트가 source-of-truth 로 사용. */
export const useSeedingRejectionReasons = (enabled = true) =>
  useQuery({
    ...curatorQueries.campaigns.seedingRejectionReasons(),
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
  });
